"use client";

import { motion } from "framer-motion";
import { Compass, HeartHandshake, Trophy } from "lucide-react";
import { Section, stagger, item } from "./Section";

const values = [
  {
    icon: Compass,
    title: "Personalised Pathways",
    copy: "1:8 teacher ratio with quarterly mentorship reviews tailored to each student's ambitions.",
  },
  {
    icon: HeartHandshake,
    title: "A Real Community",
    copy: "Small cohorts, lifelong friendships, and an alumni network that opens doors worldwide.",
  },
  {
    icon: Trophy,
    title: "Outcomes That Matter",
    copy: "Average SAT 1480. Ivy and Russell Group placements every single year since 2014.",
  },
];

export function WhyUs() {
  return (
    <Section id="why" className="bg-white">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mx-auto max-w-3xl text-center">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.25em] text-gold">
            Why Atherton
          </p>
          <h2 className="mt-3 text-balance text-4xl font-extrabold text-navy md:text-5xl">
            Built around the student,{" "}
            <span className="font-serif-body italic font-medium">
              not the system.
            </span>
          </h2>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-3"
        >
          {values.map(({ icon: Icon, title, copy }) => (
            <motion.div
              key={title}
              variants={item}
              className="group relative rounded-3xl border border-border bg-cream/40 p-8 transition-all hover:border-navy/20 hover:bg-cream hover:shadow-[var(--shadow-card)]"
            >
              <div className="grid h-14 w-14 place-items-center rounded-2xl bg-navy text-primary-foreground transition-all group-hover:bg-gold group-hover:text-navy-deep">
                <Icon className="h-6 w-6" strokeWidth={1.8} />
              </div>
              <h3 className="mt-7 font-display text-2xl font-bold text-navy">
                {title}
              </h3>
              <p className="mt-3 font-serif-body text-lg leading-relaxed text-muted-foreground">
                {copy}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </Section>
  );
}
